module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_link_image_plan-0a7d1f08757e0da3e91a6a628bd3a43d.jpg";